import 'css-chunk:src/app/containers/Home/ReportingView/ReportingView.scss';export default {
  "ReportingView": "_ReportingView_xbv4c_1"
};